import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { EnumIconNames } from "../enums/EnumIconNames";
import { Button } from "./form/Button";
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton";
import css from './SubMenu.m.scss'

interface Attrs{
    level?:number

}

export class SubMenu extends DomeComponent<Attrs>{

    protected countOfSubItems:number = 0
    public getCountOfSubItems(){
        return this.countOfSubItems
    }
    render(){
        return <div class={css.subMenu}><LoadingSpinnerForButton /></div>
    }

    async afterRender(){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement,
            <>
                {this.renderSubmenuBackButton()}
                {this.children}
                {this.renderSubmenuBackButton()}
            </>
        )
    }

    renderSubmenuBackButton(){
        return <div class={css.buttonBackContainer} >
            <Button iconName={EnumIconNames.LeftOpen} text="Назад" onClick={() => {this.hide()}}></Button>
        </div>
    }

    public show(){
        this.rootElement.classList.add(css.subMenuOpen)
    }

    public hide(){
        this.rootElement.classList.remove(css.subMenuOpen)
    }




}